// Shared constants for the legacy 1-hour-continuous session metric.
// Only the legacy omni_cross_competition table carries 1hr columns, and only
// through ONE_HR_MAX_MONTH.

export const ONE_HR_MAX_MONTH = '2026-04';

// The Ride Hailing & Taxi subcategory always shows 1-hour sessions across the
// "How is your brand growing?" section (its 15-min data is unreliable —
// Free Now's transactional 15-min sessions are inflated ~10x in the new table).
export const RIDE_HAILING_CAT = 'Ride Hailing & Taxi / Ride Hailing';

// Categories that have any 1hr data in the legacy table (used by the toggle).
export const ONE_HR_CATEGORIES = [RIDE_HAILING_CAT, 'Food Delivery /'];

export const isRideHailing = (cat) => cat === RIDE_HAILING_CAT;
